// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"6996e632","205":"70ddae21","232":"212b1351"}[chunkId] + ".chunk.js";
};